<template>
    <div id="bottom-nav">
        <ul>
            <li :class="{active: currentNav === 'home'}"
                @click="switchNav('Sidesun')">身边苏宁</li>
            <li :class="{active: currentNav === 'address'}"
                @click="switchNav('Store')">找门店</li>
            <li :class="{active: currentNav === 'server'}"
                @click="switchNav('Server')">找服务</li>
            <li :class="{active: currentNav === 'vip'}"
                @click="switchNav('Center')">我的</li>
        </ul>
    </div>
</template>
<script>

    export default {
        name: "BottomNav",
        props: {
            curNav:{
            	type: String
            }
        },
        data() {
            return {
                currentNav: this.curNav
            }
        },
        methods: {
            switchNav(type) {
                this.currentNav = type;
                this.$router.push({
                    name: type,
                    params: {cityCode: "025"}
                });
            }
        }
    }
</script>
<style scoped>
    #bottom-nav {
        position: fixed;
        left: 0;
        padding-top: 8px;
        bottom: 0;
        background: #ffffff;
        height: 88px;
        width: 100%;

        ul {
            width: 100%;
            height: 100%;
            display: -webkit-box;

            li {
                width: 100%;
                position: relative;
                -webkit-box-flex: 1;
                text-align: center;

                &:before {
                    content: '';
                    display: block;
                    margin: 0 auto;
                }

                /*这里的实现不太好，这里没法用assets模块，无法在@each 中获取图片宽高*/
                &:nth-of-type(1):before {
                    background: url("../../assets/nav-home.png") 0 0 no-repeat;
                    width: 43px;
                    height: 41px;
                    background-size: 43px 41px;
                }
                &:nth-of-type(2):before {
                     background: url("../../assets/nav-address.png") 0 0 no-repeat;
                     width: 30px;
                     height: 40px;
                     background-size: 30px 40px;
                }
                &:nth-of-type(3):before {
                     background: url("../../assets/nav-server.png") 0 0 no-repeat;
                     width: 40px;
                     height: 40px;
                     background-size: 40px 40px;
                }
                &:nth-of-type(4):before {
                     background: url("../../assets/nav-vip.png") 0 0 no-repeat;
                     width: 42px;
                     height: 40px;
                     background-size: 42px 40px;
                }

                &.active {
                    color: #ffaa00;
                    &:nth-of-type(1):before {
                         background: url("../../assets/nav-home-active.png") 0 0 no-repeat;
                         width: 43px;
                         height: 41px;
                         background-size: 43px 41px;
                    }
                    &:nth-of-type(2):before {
                         background: url("../../assets/nav-address-active.png") 0 0 no-repeat;
                         width: 30px;
                         height: 40px;
                         background-size: 30px 40px;
                    }
                    &:nth-of-type(3):before {
                         background: url("../../assets/nav-server-active.png") 0 0 no-repeat;
                         width: 40px;
                         height: 40px;
                         background-size: 40px 40px;
                    }
                    &:nth-of-type(4):before {
                         background: url("../../assets/nav-vip-active.png") 0 0 no-repeat;
                         width: 42px;
                         height: 40px;
                         background-size: 42px 40px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/bottom-nav.vue